import React from "react";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";

const TmsReportKalyanakattaSummaryReport = () => {
  return <div>Summary report</div>;
};

export default withRouter(TmsReportKalyanakattaSummaryReport);
